import { Supplier } from 'api/models/Suppliers';
import { useMemo } from 'react';

export type UseSupplierLabelsProps = {
  suppliers?: Supplier[];
  flip?: boolean;
};

export type UseSupplierLabels = Record<string, string>;

export default ({ suppliers, flip = false }: UseSupplierLabelsProps): UseSupplierLabels => {
  return useMemo<UseSupplierLabels>(() => {
    if (!suppliers) return {};

    // description can be duplicated, in which case the name is appended below
    // reduce quadratic O(n^2) complexity to linear O(2n) by first mapping duplicates
    const duplicateDescriptions = suppliers.reduce((a, s) => {
      if (s.description) a[s.description] = a[s.description] != null;
      return a;
    }, {} as Record<string, boolean>);

    // a dictionary of labels to values for lists.suppliers (keys) and value lookup for BE
    return suppliers.reduce((a, s) => {
      const label = !s.description
        ? s.name
        : duplicateDescriptions[s.description]
        ? `${s.description} (${s.name})`
        : s.description;
      if (flip) a[label] = s.name;
      else a[s.name] = label;
      return a;
    }, {});
  }, [flip, suppliers]);
};
